export function stripHtmlFormatter(html: string): string {
  return html.replace(/<br \/>/g, "\n").replace(/<[^>]*>/g, "");
}
